import { useIntl } from "react-intl";

export default function useIsPortuguese() {
  const intl = useIntl();

  return intl.locale.startsWith("pt") ? "pt-BR" : "en-US";
}
